export type ImageFormatKey =
  | 'indexed8'
  | 'truecolor_alpha'
  | 'truecolor'
  | 'alpha8'
  | 'argb8888'
  | 'rgb565';
export const IMAGE_FORMATS: ImageFormatKey[] = [
  'indexed8',
  'truecolor_alpha',
  'truecolor',
  'alpha8'
];
